import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment.prod';
@Injectable({
  providedIn: 'root'
})


export class CommonService {
  private _getRoleListUrl = `${environment.api}/CommonRecord/getRoleListByid`;
  private _getCustomerListUrl = `${environment.api}/CommonRecord/getCustomerListByid`;
  private _activeUserUrl = `${environment.api}/User/getuserListbyid`;
  private _getPerListUrl = `${environment.api}/CommonRecord/getRolePermissions`;
  private _savePerListUrl = `${environment.api}/CommonRecord/saveRolePermissions`;

  private _getCustomerListadmin = `${environment.api}/CommonRecord/getCustomerListsuperadmin`;




  constructor(private http: HttpClient) { }
  getRoleList(data)
  {
      return this.http.post<any>(this._getRoleListUrl,data);
  }

  getRolePerByid(data)
  {
     return this.http.post<any>(this._getPerListUrl,data);
  }

  saveRolePerByid(data)
  {
     return this.http.post<any>(this._savePerListUrl,data);
  }

  getCustomerList(data)
  {
     return this.http.post<any>(this._getCustomerListUrl,data);
  }
  getCustomerListsuperadmin(data)
  {
     return this.http.post<any>(this._getCustomerListadmin,data);
  }



}
